import { ImportTemplateListResponse } from "../../../shared/entities/ImportTemplateListResponse";
import { TranslationService } from "../../../../services/TranslationService";
import ImportTemplateEditBase, {
  ImportTemplateComponentProps
} from "./ImportTemplateEditBase";
import EditItem from "./Components/EditItem";
import { TextEditor } from "../../../shared/components/Editors";
import { GroupBy, OptionalMap } from "../../../../utils/Utils";
import { useCallback, useEffect, useState } from "react";
import ImportTemplateService, {
  ImportTemplateId
} from "../../../../services/ImportTemplateService";
import DictionaryService from "../../../../services/DictionaryService";
import { useHistory } from "react-router-dom";
import { ImportService } from "../../../../services/ImportService";
import Collapsable from "../../../shared/bootstrap/Collapsable";

const DICTIONARY_ENTITY = 11;

const ImportTemplateEditDictionaryManual = () => {
  const [showDetail, setShowDetail] = useState(false);
  const { translate } = TranslationService;
  const history = useHistory();
  const state = history.location.state;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<
    ImportTemplateListResponse.Item | undefined
  >();
  const dictionaryName = (
    state as {
      ImportDictionaryID: number;
      ImportDictionaryID_ref: any;
      ImportID: any;
      ImportTemplateID: any;
      Name: string;
    }
  )?.Name;
  const importDefinitions = ImportService.getImports();
  const order = [DICTIONARY_ENTITY];

  const requestData = async () => {
    try {
      const dictPromise = DictionaryService.getList();
      const result = await ImportTemplateService.getList();
      const dictionaries = await dictPromise;
      if (result instanceof Error || dictionaries instanceof Error) {
        return;
      }
      const groupImports =
        OptionalMap(result, (x) =>
          Object.values(GroupBy(x.list, (y) => y.Entity))
        ) ?? [];
      const sortedGroupImports = order
        .filter((x) => importDefinitions[x].isEnabled)
        .map((x) => groupImports.find((y) => y[0].Entity === x)!)
        .filter((x) => x);
      let importDetected = sortedGroupImports[0].find(
        (imp) => imp.Name === (state as any)?.Name
      );
      if (!importDetected) {
        importDetected = sortedGroupImports[0].find(
          (imp) => imp.ImportTemplateID === (state as any)?.ImportTemplateID
        );
      }

      setData(importDetected);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const requestDataCallback = useCallback(requestData, []);
  useEffect(() => {
    requestDataCallback();
  }, [requestDataCallback]);

  const goToDictionaries = () =>
    history.push(
      `/${TranslationService.currentLanguage}/ImportTemplateManual?entityId=` +
        ImportTemplateId.Dictionary
    );
  const Header = () => {
    return (
      <div className="mb-3 mt-4">
        <h5 className="mb-4">
          {translate.DictionaryImportSettings} "{dictionaryName}"
        </h5>
        <details className="mt-3" onClick={() => setShowDetail((x) => !x)}>
          <summary className="ps-1 mb-2">
            <h6 style={{ display: "unset" }}>
              {TranslationService.translate.SeeTheRequirementsOfTheFileToImport}
            </h6>
          </summary>
        </details>
        <Collapsable show={showDetail}>
          {TranslationService.translate.RequirementsOfTheFileToImport.split(
            "\n"
          ).map((x, i) => (
            <div key={i} className="text-muted ms-3">
              {x}
            </div>
          ))}
        </Collapsable>
      </div>
    );
  };

  const AdvancedOptions = ({
    data,
    updateModel
  }: ImportTemplateComponentProps) => (
    <EditItem label={<>{translate.SendResultsTo}</>}>
      <TextEditor
        onChange={updateModel("EmailReturn")}
        defaultValue={data?.EmailReturn}
      />
    </EditItem>
  );
  return !isLoading ? (
    <div className="container">
      <ImportTemplateEditBase
        entityId={DICTIONARY_ENTITY}
        Header={Header}
        reload={goToDictionaries}
        requiredFieldIds={[]}
        data={data}
        AdvancedOptions={AdvancedOptions}
        exposeAdvanced
        showName
        cancelBtn
      />
    </div>
  ) : null;
};

export default ImportTemplateEditDictionaryManual;
